import {Inject, Injectable, PLATFORM_ID, TransferState} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {DOCUMENT} from '@angular/common';

import {ApiHelper} from '../../../../../services/api.helper';
import {ToolsService} from '../../../../../services/tools.service';
import {AppConfigService} from '../../../../../services/app-config.service';
import {WPPostCareServiceTypePage} from '../typings/WPPostCareServiceTypePage';
import {WPPostSymptomPage} from '../typings/WPPostSymptomPage';

@Injectable()
export class StaticSearchContentDataV2Service {
  constructor(
    private http: HttpClient,
    private apiHelper: ApiHelper,
    private tools: ToolsService,
    private appConfigService: AppConfigService,
    private transferState: TransferState,
    @Inject(PLATFORM_ID) private platformId: any,
    @Inject(DOCUMENT) private doc: any,
  ) {}

  public GetCareServicePostBySlug(slug: string): Observable<WPPostCareServiceTypePage> {
    const apiUrl: string = this.appConfigService.appConfig.amazonS3WpUrl;
    const endpoint: string = `${apiUrl}wp/careservicetype/careservicetype-${slug}.json`;

    return this.http
      .get<WPPostCareServiceTypePage>(endpoint)
      .pipe(catchError((error) => this.apiHelper.handleError(error)));
  }

  public GetSymptomPostBySlug(slug: string): Observable<WPPostSymptomPage> {
    const apiUrl: string = this.appConfigService.appConfig.amazonS3WpUrl;
    const endpoint: string = `${apiUrl}wp/symptom/symptom-${slug}.json`;

    return this.http.get<WPPostSymptomPage>(endpoint).pipe(catchError((error) => this.apiHelper.handleError(error)));
  }
}
